// Write your code here.
import {Component} from 'react'
import './index.css'

class LettersCalculator extends Component {
  state = {
    searchInput: '',
  }

  onChangeSearchInput = event => {
    this.setState({searchInput: event.target.value})
  }

  render() {
    const {searchInput} = this.state

    return (
      <div className="app-container">
        <div className="letters-calculator-container">
          <div className="calculator-section">
            <h1 className="heading">Calculate the Letters you enter</h1>
            <div className="input-container">
              <label htmlFor="phraseInput" className="label-text">
                Enter the phrase
              </label>
              <input
                id="phraseInput"
                type="text"
                className="phrase-input"
                placeholder="Enter the phrase"
                value={searchInput}
                onChange={this.onChangeSearchInput}
              />
            </div>
            <div className="count-container">
              <p className="count-text">No.of letters: {searchInput.length}</p>
            </div>
          </div>
          <div className="image-section">
            <img
              src="https://assets.ccbp.in/frontend/react-js/stop-watch-with-calculator-img.png"
              alt="letters calculator"
              className="calculator-image"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default LettersCalculator
